const DEFAULT_STATE = {
    loggedInUser: null,
    loginTimestamp: null,
    recaptcha: null,
    siteToken: null,
    key: null,
};


const fnList = {
    RECAPTCHA_RESPONSE: (state, payload) => ({
        ...state,
        recaptcha: payload,
    }),
    SITE_TOKEN: (state, payload) => ({
        ...state,
        siteToken: payload,
    }),
    LOGGED_IN: (state, payload) => ({
        ...state,
        loggedInUser: payload.user,
        loginTimestamp: payload.timestamp,
        key: payload.key,
    }),
    LOGGED_OUT: (state, payload) => ({
        ...state,
        loggedInUser: payload,
        loginTimestamp: null,
        key: null,
    }),
    UPDATE_PROFILE: (state, payload) => ({
        ...state,
        loggedInUser: {
            ...state.loggedInUser,
            ...payload,
        },
    }),
};

export default (state = DEFAULT_STATE, { type, payload }) => {
    const fn = fnList[type];
    if (typeof fn === 'function') {
        return fn(state, payload);
    }
    return state;
};



//////////////////
// WEBPACK FOOTER
// ./src/reducers/userReducers.js
// module id = 1067
// module chunks = 0